import Vue from "vue";
import Vuex from "vuex";
import stepsConfiguration from './store-step-configuration.js';
import  i18n  from '../src/i18n';
import storeStepConfiguration from "./store-step-configuration.js";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        currentStep: 'ref_brouette',
        steps: ['ref_brouette'],
        apiUrlBase : process.env.VUE_APP_API_URL_BASE ?? '/wp-json/hae/',
        apiUrlGetProductsbySku : "getProductsBySkus/",
        apiUrlGetSparePartsbySku : "getSparePartsBySku/",
        refBrouetteConnue : null,
        showPreviousBtn : true,
        stepsAnswers: [
            {
                breadcrumbLabel: i18n.t("titlePage"),
                images: ['', '', '']
            }
        ],
        stepsConfiguration
    },
    mutations: {
        // Init le store quand l'on reviens sur l'élément type_de_piece depuis l'echec de la recherche input
        giveStoreInit(state){
            if(state.steps.length <= 2){
                state.steps.shift();
                state.stepsAnswers.shift()
            }
            storeInit(state);
        },        

        // Logique de l'étape actuelle
        setCurrentStep(state, option) {
            setStep(state, option);
        },

        // L'index de stepsName utilisé dans le breadcrumb
        goToStep(state, index_of_step) {
            const chosen_step = state.steps[index_of_step]
            state.steps.splice(index_of_step + 1)
            state.stepsAnswers.splice(index_of_step + 1)
            state.currentStep = chosen_step
            setAnim();
        },

        // Retour en arrière avec l'étape " NON " choisie 
        jumpToStep(state){
            storeReinit(state); // Réinitialise le store
            state.steps[1] = stepsConfiguration.ref_brouette.options[1].value // L'étape 1 c'est type_de_piece
            state.currentStep = stepsConfiguration.ref_brouette.options[1].value
            state.steps.push[storeStepConfiguration.ref_brouette, storeStepConfiguration.type_de_piece] // on push les objets dans le store
            setAnim();
        },


        isFinish(state, index_of_step){
            const chosen_step = state.steps[index_of_step]
            state.currentStep = chosen_step
        },
    }
})

/**
 * Set l'étape courante et met à jour les listes
 * 
 * @param {state} state State du store
 * @param {string} step Etape à paramétrer
 */
function setStep(state, step) {
    state.steps.push(step.value);
    state.stepsAnswers.push(step);
    state.currentStep = step.value;
    setAnim();
}

function setAnim() {
    document.getElementById("questionnaire").animate([ { opacity: 0 }, { opacity: 1 } ], 500);
}

function storeInit(state){
    state.currentStep = 'ref_brouette'
    state.steps.push('ref_brouette')
    state.refBrouetteConnue = null
    state.showPreviousBtn = true
    state.stepsAnswers.push({
        breadcrumbLabel: i18n.t("titlePage"),
        images: ['', '', '']
    })
}

function storeReinit(state){
    state.steps = [];
    state.stepsAnswers = [];
    storeInit(state)
}